import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'INITIAL_GET',
}

const INITIAL_STATE = {
  itens: [],
  modal: { show: false, data: null },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
  filterCompanyId: null,
}

export default function useCadastroOcPrevista() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      onInit(selectedTp) {
        setState(prev => ({
          ...prev,
          selectedTp,
          loadingMessage: selectedTp ? LOAD_MESSAGE.INITIAL_GET : LOAD_MESSAGE.NONE,
          errorMessage: selectedTp ? null : 'Selecione o Operador Logístico',
        }))
      },
      async getLista(tp_id, companyId) {
        try {
          const data = await EstoqueHttp.getOcPrevistas(tp_id, companyId || undefined)
          setState(prev => ({ ...prev, itens: data, loadingMessage: LOAD_MESSAGE.NONE }))
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        }
      },
      onBtnNovo() {
        setState(prev => ({ ...prev, modal: { show: true, data: null } }))
      },
      onRowClick(item) {
        setState(prev => ({ ...prev, modal: { show: true, data: item } }))
      },
      onModalClose() {
        setState(prev => ({ ...prev, modal: { show: false, data: null } }))
      },
      onModalSave(saved) {
        setState(prev => {
          const copy = { ...prev }
          copy.modal = { show: false, data: null }

          if (!saved) return copy
          const idx = (copy.itens || []).findIndex(x => x.id === saved.id)
          if (idx === -1) copy.itens = [saved, ...(copy.itens || [])]
          else copy.itens[idx] = saved
          return copy
        })
      },
      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },
      onFilterCompanyChange(empresa) {
        setState(prev => ({
          ...prev,
          filterCompanyId: empresa ? empresa.id : null,
          loadingMessage: prev.selectedTp ? LOAD_MESSAGE.INITIAL_GET : LOAD_MESSAGE.NONE,
        }))
      },
      resetError() {
        setState(prev => ({ ...prev, errorMessage: null }))
      },
    }
  }, [])

  return { state, localDispatch }
}
